import { FC, useState } from 'react';
import { Reporting, ReportingContextState } from 'modules/iterableGoals/types';
import { initialReportingContextState, ReportingContext } from './ReportingContext';
import { useGoalsTranslations } from '../hooks';

export const ReportingContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [reportingBy, setReportingBy] = useState(initialReportingContextState.reportingBy);
  const { t } = useGoalsTranslations();
  const getReportingTranslation = (key: string) => t(`${key}.${reportingBy}`);

  const context: ReportingContextState = {
    isRevenue: reportingBy === Reporting.REVENUE,
    reportingBy,
    updateReportingBy: (reporting: Reporting) => {
      setReportingBy(reporting);
    },
    getReportingTranslation,
  };

  return <ReportingContext.Provider value={context}>{children}</ReportingContext.Provider>;
};
